import { render, staticRenderFns } from "./memberTopic.vue?vue&type=template&id=b2068692&scoped=true"
import script from "./memberTopic.vue?vue&type=script&lang=js"
export * from "./memberTopic.vue?vue&type=script&lang=js"
import style0 from "./memberTopic.vue?vue&type=style&index=0&id=b2068692&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2068692",
  null
  
)

export default component.exports